import React from "react";

const CircularProgress: React.FC<{
  circleWidth?: number;
  width?: number;
  height?: number;
  color?: string;
  children?: React.ReactNode;
  target?: number;
  value?: number;
}> = ({
  circleWidth = 4,
  width = 100,
  height = 100,
  color,
  children,
  target = 100,
  value = 0,
}) => {
  const percentage = (value / target) * 100;
  return (
    <div className="relative" style={{ width, height }}>
      <svg className="w-full h-full" viewBox="0 0 100 100">
        {/* <!-- Background circle --> */}
        <circle
          className="text-gray-200 stroke-current"
          strokeWidth={circleWidth}
          cx="50"
          cy="50"
          r="40"
          fill="transparent"
        ></circle>
        {/* <!-- Progress circle --> */}
        <circle
          style={{ stroke: color }}
          className={`progress-ring__circle stroke-current`}
          strokeWidth={circleWidth}
          strokeLinecap="round"
          cx="50"
          cy="50"
          r="40"
          fill="transparent"
          strokeDasharray="251.1"
          // strokeDashoffset={`calc(251.2 - (251.2 * ${percentage}) / 100)`}
          strokeDashoffset={`calc(251.1 - (251.1 * ${Math.min(
            percentage,
            100
          )}) / 100)`}
        ></circle>
        {/* <!-- Center text --> */}
        {/* <text
          x="50"
          y="50"
          font-family="Verdana"
          font-size="12"
          text-anchor="middle"
          alignmentBaseline="middle"
        > */}
        {/* </text> */}
      </svg>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        {children}
      </div>
    </div>
  );
};

export default CircularProgress;
